/** Нэг оруулах байрлалд хэдэн баннер дарааллаар оруулах */
export const BANNERS_PER_INSERTION = 3;

export const getBannerPositionsForPage = (
  jobs: any[],
  bannersToShow: any[],
  _currentPage: number
): number[] => {
  if (bannersToShow.length === 0 || jobs.length === 0) {
    return [];
  }

  const positions: number[] = [];
  const maxInsertionPoints = Math.ceil(
    bannersToShow.length / BANNERS_PER_INSERTION
  );

  let featuredCount = 0;
  let bannerCount = 0;
  let lastFeaturedIndex = -1;

  // АЛХАМ 1: Featured job-уудыг тоолох
  for (let i = 0; i < jobs.length; i++) {
    const job = jobs[i];
    const featuredUntil = job.isFeatured ?? job.is_featured;
    const isFeatured =
      featuredUntil && featuredUntil > Math.floor(Date.now() / 1000);

    if (isFeatured) {
      featuredCount++;
      lastFeaturedIndex = i;

      // 10, 20, 30... хүрэх бүрт баннер оруулах
      if (featuredCount % 10 === 0 && bannerCount < maxInsertionPoints) {
        positions.push(i + 1);
        bannerCount++;
      }
    }
  }

  // АЛХАМ 2: Featured багц дуусаагүй бол сүүлчийн featured-ийн араас
  if (
    featuredCount > 0 &&
    featuredCount % 10 !== 0 &&
    bannerCount < maxInsertionPoints
  ) {
    positions.push(lastFeaturedIndex + 1);
    bannerCount++;
  }

  // АЛХАМ 3: Featured огт байхгүй бол
  if (featuredCount === 0) {
    // Job 20-оос доош бол голд нь 1 баннер
    if (jobs.length <= 20 && bannerCount < maxInsertionPoints) {
      const middlePosition = Math.floor(jobs.length / 2);
      positions.push(middlePosition);
      bannerCount++;
    }
    // Job 20-оос их бол [11, 31, 51]
    else if (bannerCount < maxInsertionPoints) {
      const defaultPositions = [10, 30, 50];

      for (const pos of defaultPositions) {
        if (bannerCount >= maxInsertionPoints) break;
        if (pos <= jobs.length) {
          positions.push(pos);
          bannerCount++;
        }
      }
    }
  }

  // АЛХАМ 4: Үлдсэн баннерууд - сүүлчийн баннераас +20 job бүр
  while (bannerCount < maxInsertionPoints && positions.length > 0) {
    const nextPosition = positions[positions.length - 1] + 20;

    if (nextPosition <= jobs.length) {
      positions.push(nextPosition);
      bannerCount++;
    } else {
      break;
    }
  }

  return positions.sort((a, b) => a - b);
};

export const getBannersForCurrentPage = (
  banners: any[],
  currentPage: number
): any[] => {
  if (!banners || banners.length === 0) {
    return [];
  }

  const bannersPerPage = 9;
  const totalPages = Math.ceil(banners.length / bannersPerPage);

  // Хуудасны тоо баннерын нийт хуудаснаас хэтэрсэн бол хоосон буцаах
  if (currentPage > totalPages) {
    return [];
  }

  const startIndex = (currentPage - 1) * bannersPerPage;
  const endIndex = Math.min(startIndex + bannersPerPage, banners.length);

  return banners.slice(startIndex, endIndex);
};

/**
 * Job болон баннеруудыг хольж render хийх
 */
export const getMixedJobsAndBanners = (
  jobs: any[],
  banners: any[],
  bannersToShow: any[],
  filterKey: string,
  currentPage: number
): Array<{ type: 'job' | 'banner'; data: any; key: string }> => {
  const result: Array<{ type: 'job' | 'banner'; data: any; key: string }> = [];

  // Баннер байхгүй бол зөвхөн job-уудыг буцаах
  if (bannersToShow.length === 0) {
    return jobs.map((job) => ({
      type: 'job' as const,
      data: job,
      key: `job-${job.id}`,
    }));
  }

  const bannerPositions = getBannerPositionsForPage(
    jobs,
    bannersToShow,
    currentPage
  );

  let bannerIndex = 0;

  for (let i = 0; i < jobs.length; i++) {
    // Энэ байрлалд баннер орох эсэхийг шалгах
    if (bannerPositions.includes(i) && bannerIndex < bannersToShow.length) {
      for (
        let k = 0;
        k < BANNERS_PER_INSERTION && bannerIndex < bannersToShow.length;
        k++
      ) {
        result.push({
          type: 'banner' as const,
          data: bannersToShow[bannerIndex],
          key: `banner-${bannerIndex}-${currentPage}-${filterKey}-${bannersToShow[bannerIndex]?.id}`,
        });
        bannerIndex++;
      }
    }

    // Job-ийг нэмэх
    result.push({
      type: 'job' as const,
      data: jobs[i],
      key: `job-${jobs[i].id}`,
    });
  }

  return result;
};
